import t from "./restArguments.js";
import n from "./now.js";
function e(e, u, o) {
  var r,
    l,
    i,
    a,
    c,
    m = function m() {
      var t = n() - l;
      u > t ? r = setTimeout(m, u - t) : (r = null, o || (a = e.apply(c, i)), r || (i = c = null));
    },
    s = t(function (t) {
      return c = this, i = t, l = n(), !r && (r = setTimeout(m, u), o && (a = e.apply(c, i))), a;
    });
  return s.cancel = function () {
    clearTimeout(r), r = i = c = null;
  }, s;
}
export { e as default };